import m from './menu.vue';

export default m;
